import React, { useContext, useState, useEffect, useRef } from 'react';
import { Routes, Route } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import { jwtDecode } from 'jwt-decode';
import { GlobalStateDataContext } from './context-api/data-provider/GlobalStateDataProvider';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import './App.css';
import LoginPage from './pages/login-page/Login-Page';
import NoMatch from './composed/nomatch/NoMatch';
import { publicIp, publicIpv4, publicIpv6 } from 'public-ip';
import DashboardOld from './pages/dashboard-page/Dashboard';
import PricePlanPage from './pages/priceplan-page/PricePlan-Page';
import CheckZipcodePage from './pages/checkzipcode-page/CheckZipcode-Page';
import SignupPage from './pages/signup-page/Signup-Page';
import SignupHeader from './composed/signupHeader/SignupHeader';
import { Error404 } from './composed/error404/Error404';
import { API_NETWORK_ERROR, localStorageKeys } from './utils/constants';
import { getUrlPath } from './utils/getUrls';
import HomePage from './pages/home-page/Home-Page';
import ForgotPasswordPage from './pages/login-page/ForgotPassword-Page';
import ResetPasswordPage from './pages/login-page/ResetPassword-Page';
import IdleLogoutModal from './composed/idleLogoutModal/idleLogoutModal';
import { SignUpDataContext } from './context-api/data-provider/SignupDataProvider';
import FooterHome from './composed/footerHome/FooterHome';
import { isMobile, isIpad, isDesktop } from './utils/ScreenSizeHelper';
import OrderDashboard from './pages/order/OrderDashboard';
import Header from './composed/header/Header';
import Product from './composed/products/Product';
import ManageDeliveries from './composed/managedeliveries/ManageDeliveries';
import PageBase from './composed/pagebase/Pagebase';
import { KitchenOperationUpdateContext } from './context-api/data-provider/UpdateOperationDataProvider';
import PageReloaded from './composed/pagereloaded/PageReloaded';
import AddEditProduct from './composed/products/AddProduct';
import AddProduct from './composed/products/AddProduct';
import ReferralStatistics from './composed/referralStatistics/ReferralStatistics';
import ReferralStatisticsPage from './pages/referralstatistics-page/ReferralStatistics-Page';
import { RevenueSharingContext } from './context-api/data-provider/RevenueSharingDataProvider';
import LegalCenter from './pages/agreements/LegalTerms';
import ContactUs from './pages/contactus-page/ContactUs';
import MerchantTermsOfService from './pages/agreements/MerchantTermsOfService';
import MerchantTermsPage from './pages/agreements/MerchantTermsOfService';
import StorePackageWalk from './pages/salesbooking-page/index.js';
import MobileAppNotReady from './composed/MobileAppNotReady/MobileAppNotReady.js';
import AccountSettings from './pages/accountsettings/AccountSettings-Page.js';
import StoreSettings from './pages/storesettings-page/StoreSettings-Page.js';
import DiscountSettings from './pages/discountsettings-page/DiscountSettings-Page.js';
import PhoneVerifyOtp from './pages/phoneverify-page/PhoneVerifyOtp-Page.js';
import DeliveryDriversPage from './pages/deliverydrivers-page/DeliveryDrivers-Page.js';
import UploadMenuImage from './pages/order/UploadMenuImage';
import MerchantContactUs from './pages/contactus-page/ConatctUsNew.js';
import ContactUsNew from './pages/contactus-page/ConatctUsNew.js';
import ScrollToTop from './utils/ScrollToTop.js';
import FooterMobileOnly from './composed/footerHome/FooterMobileOnly.js';
import MerchantFeedback from './pages/feedback/MerchantFeedBack.js';
import BetaBanner from './pages/reportUiBug/BetaBugBanner.js';
import ReportUiBugForm from './pages/reportUiBug/ReportBugForm.js';

function App() {
  const {
    OnLoadInformation,
    onLoadInfoResponse,
    showCongrat,
    showSignup,
    showPricePlan,
    isLoggedIn,
    pageReloaded,
    setPageReloaded,
    setisLoggedIn,
    OnPhoneVerify,
  } = useContext(GlobalStateDataContext);
  const { onRevenueSharingDataAPI } = useContext(RevenueSharingContext);

  const { idle, showIdealPopup, setShowIdealPopup, onLogout } = useContext(SignUpDataContext);
  const { kitchenUpdateAPIResponse } = useContext(KitchenOperationUpdateContext);
  const kitchenUpdateLatestRef = useRef(kitchenUpdateAPIResponse);
  kitchenUpdateLatestRef.current = kitchenUpdateAPIResponse;
  const prevKitchenOpLoadingRef = useRef(false);
  const kitchenOnLoadBootstrapDoneRef = useRef(false);
  const onLoadKitchenInfoSeqRef = useRef(0);
  const [publicIp, setPublicIp] = useState(null);
  const { data, loading, message, success } = onLoadInfoResponse;
  const { TOKEN, FINGER_PRINT_USER } = localStorageKeys;
  const TokenLocalStorage = () => localStorage.getItem(TOKEN);

  const checkUrl = ['/', '/forgotpassword', '/checkzipcode'].some((path) =>
    getUrlPath().includes(path)
  );

  useEffect(() => {
    const generateFingerprint = async () => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const id = result.visitorId;
        if (id) {
          localStorage.setItem(FINGER_PRINT_USER, id);
        }
      } catch (error) {
        console.error('Fingerprint error:', error);
      }
    };

    const gettingFingerPrint = () => localStorage.getItem(FINGER_PRINT_USER);
    if (gettingFingerPrint() === null) {
      generateFingerprint();
    }
  }, []);

  useEffect(() => {
    setPageReloaded(true);
  }, []);

  useEffect(() => {
    const checkDailyReload = () => {
      const today = new Date().toDateString(); // e.g., "Tue May 14 2025"
      const lastReloadDate = localStorage.getItem('lastReloadDate');

      if (lastReloadDate !== today) {
        // Store today's date before reloading
        localStorage.setItem('lastReloadDate', today);
        window.location.reload();
      }
    };

    checkDailyReload(); // Check immediately on load

    // Optional: keep checking every 10 minutes in case the app stays open overnight
    const interval = setInterval(checkDailyReload, 60 * 60 * 1000); // 1hr

    return () => clearInterval(interval); // Clean up on unmount
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      kitchenOnLoadBootstrapDoneRef.current = false;
      prevKitchenOpLoadingRef.current = false;
      return;
    }

    const { loading: kitchenOpLoading } = kitchenUpdateAPIResponse;
    const wasKitchenOpLoading = prevKitchenOpLoadingRef.current;
    prevKitchenOpLoadingRef.current = kitchenOpLoading;

    if (kitchenOpLoading) return;

    const updateJustResolved = wasKitchenOpLoading && !kitchenOpLoading;
    const needBootstrapLoad = !kitchenOnLoadBootstrapDoneRef.current;

    if (!updateJustResolved && !needBootstrapLoad) return;

    /* Only re-fetch kitchen info after a kitchen-op API finishes successfully.
       Add/update failures set success: false — refreshing here hid errors and showed a pointless loader. */
    if (updateJustResolved && kitchenUpdateLatestRef.current?.success !== true) {
      return;
    }

    const seq = ++onLoadKitchenInfoSeqRef.current;
    publicIpv4().then((ip) => {
      if (seq !== onLoadKitchenInfoSeqRef.current) return;
      if (kitchenUpdateLatestRef.current?.loading) return;

      setPublicIp(ip);

      const decodedToken = jwtDecode(TokenLocalStorage());
      const { kitchenName } = decodedToken;
      const payload = {
        public_ip: ip,
        kitchenName: kitchenName,
      };
      OnLoadInformation(payload);
      const payloadData = { account_id: kitchenName };
      onRevenueSharingDataAPI(payloadData);
      idle.start();

      kitchenOnLoadBootstrapDoneRef.current = true;
    });
  }, [kitchenUpdateAPIResponse, isLoggedIn]);

  if (success === false && message === API_NETWORK_ERROR) {
    return <Error404 />;
  }

  // Mobile App Not ready Yet
  if (isMobile && !isLoggedIn) {
    return (
      <div
        style={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <SignupHeader />
        <BetaBanner />
        <div style={{ flex: 1 }}>
          <ScrollToTop />
          <Routes>
            <Route path='/' element={<HomePage />}></Route>
            <Route path='*' element={<MobileAppNotReady />}></Route>
            <Route path='/merchant-contact' element={<StorePackageWalk />}></Route>
            <Route path='/merchant-feedback' element={<MerchantFeedback />} />
            <Route path='/contactus' element={<ContactUsNew />}></Route>
            <Route path='/report-bug' element={<ReportUiBugForm />}></Route>
          </Routes>
        </div>
        <FooterMobileOnly />
      </div>
    );
  }

  if (
    (isIpad || isDesktop) &&
    isLoggedIn &&
    data?.data?.data.KitchenInfo?.phone_verified_status === false
  ) {
    return (
      <>
        <Header />
        <PhoneVerifyOtp />
      </>
    );
  }

  if (isIpad || isDesktop) {
    return (
      <div
        className='app-main-layout'
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {isLoggedIn === false && <SignupHeader />}
        <BetaBanner />
        {/* {showIdealPopup && (
        <IdleLogoutModal
         showIdealPopup={showIdealPopup}
          onClose={() => {
            setShowIdealPopup(false);
          }}
          idle={idle}
          logout={onLogout}
        />
      )} */}

        {isLoggedIn && checkUrl ? <Header /> : ''}

        <PageBase>
          <Routes>
            <Route path='/' element={isLoggedIn ? <OrderDashboard /> : <HomePage />}></Route>
            <Route path='/report-bug' element={<ReportUiBugForm />}></Route>
            <Route
              path='/checkzipcode'
              element={isLoggedIn ? <OrderDashboard /> : <CheckZipcodePage />}
            ></Route>
            <Route path='/phoneverify' element={<PhoneVerifyOtp />}></Route>
            <Route
              path='/referralstatistics'
              element={
                isLoggedIn ? <ReferralStatisticsPage /> : <NoMatch textmessage='No route found' />
              }
            ></Route>

            <Route
              path='/accountinfo'
              element={isLoggedIn ? <AccountSettings /> : <NoMatch textmessage='No route found' />}
            ></Route>

            <Route
              path='/storesettings'
              element={isLoggedIn ? <StoreSettings /> : <NoMatch textmessage='No route found' />}
            ></Route>

            <Route
              path='/priceplan'
              element={
                showPricePlan && isLoggedIn === false ? (
                  <PricePlanPage />
                ) : (
                  <NoMatch textmessage='No route found' />
                )
              }
            ></Route>
            <Route
              path='/signup'
              element={showSignup && isLoggedIn === false ? <SignupPage /> : <CheckZipcodePage />}
            ></Route>

            <Route path='/login' element={isLoggedIn ? <OrderDashboard /> : <LoginPage />}></Route>
            {/* <Route path='/dashboard' element={isLoggedIn ? <DashboardOld /> : <LoginPage />}></Route> */}
            <Route
              path='/forgotpassword'
              element={isLoggedIn === false ? <ForgotPasswordPage /> : <OrderDashboard />}
            />
            <Route
              path='/resetpasswordkitchen'
              element={
                isLoggedIn === false ? (
                  <ResetPasswordPage />
                ) : (
                  <NoMatch textmessage='No route found' />
                )
              }
            />
            <Route
              path='/menu'
              element={
                isLoggedIn ? <Product /> : <NoMatch textmessage='Log in to access the Menu page.' />
              }
            />
            <Route
              path='/addproduct'
              element={
                isLoggedIn ? (
                  <AddProduct />
                ) : (
                  <NoMatch textmessage='Log in to access the Menu page.' />
                )
              }
            />

            <Route
              path='/discountsettings'
              element={
                isLoggedIn ? (
                  <DiscountSettings />
                ) : (
                  <NoMatch textmessage='Log in to access the Discount page.' />
                )
              }
            />
            <Route
              path='/deliverydrivers'
              element={
                isLoggedIn ? (
                  <DeliveryDriversPage />
                ) : (
                  <NoMatch textmessage='Log in to access the Manage Deliveries page.' />
                )
              }
            />

            <Route
              path='/uploadmenuimage'
              element={
                isLoggedIn ? (
                  <UploadMenuImage />
                ) : (
                  <NoMatch textmessage='Log in to access the Menu upload page.' />
                )
              }
            />

            <Route path='/termsofservice' element={<LegalCenter />}></Route>
            <Route path='/privacypolicy' element={<LegalCenter />}></Route>
            <Route path='/merchanttermsofservice' element={<MerchantTermsPage />}></Route>
            <Route path='/merchant-contact' element={<StorePackageWalk />}></Route>
            <Route path='/merchant-feedback' element={<MerchantFeedback />} />

            <Route
              path='/contactus'
              element={!isLoggedIn ? <ContactUsNew /> : <NoMatch textmessage='No route found' />}
            ></Route>

            <Route path='*' element={<NoMatch textmessage='No route found' />}></Route>
          </Routes>
          {!isLoggedIn && <FooterHome />}
        </PageBase>

        {isLoggedIn && (
          <Dialog
            open={pageReloaded}
            // onClose={handleClose}  // This will close dialog if it clicked anywhere on screen
            className='alert-dialog-wrapper'
          >
            <PageReloaded />
          </Dialog>
        )}
      </div>
    );
  }
}

export default App;
